import { axiosInstance, axiosInstancePost } from './config';

export const getAllGifts_req = async () => {
    const response = await axiosInstance.post('/getAllGifts', {
        jwt:
            'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJwbGF0Zm9ybSI6InZrIiwidXNlcklkIjoyLCJ1aWQiOiIyX2ZiIiwidGVhbUlkIjpudWxsLCJpYXQiOjE1OTQwMzM4MDR9.ErRYY_HdhTAZuSaUNaEk_8MS7rKuQOT7skCQN-6GluE',
    });
    return response.data;
};
